import { render, staticRenderFns } from "./TallyList.vue?vue&type=template&id=26fde980&"
import script from "./TallyList.vue?vue&type=script&lang=js&"
export * from "./TallyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports